
import { defineComponent, ref, reactive, toRefs, onMounted, computed, onUnmounted } from 'vue'
import { InfoCircleOutlined } from '@ant-design/icons-vue'
import router from '@/router/index'
import { useRoute } from 'vue-router'
import Navatop from '@/components/navtopF10.vue'
import api from '@/api/allApi'
import Table from '@/components/table.vue'
import globalsets from '@/utils/globalsets'
import ws from '../../websocket/index'
import f10ApiUS from '@/api/f10ApiUS'
import { isLocalDev } from '@/api/config'
export default defineComponent({
  props: {
    itemdata: {
      type: Object,
      default: () => {
        return {}
      }
    },
    pageSourceData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    theme: {
      type: String,
      default: () => {
        return ''
      }
    },
    token: {
      type: String,
      default: () => {
        return ''
      }
    }
  },
  components: { Table, InfoCircleOutlined },
  setup(props, context) {
    const route = useRoute()
    const pageData: any = reactive({
      list: [],
      list2: [],
      tooltip: {},
      overflow: {},
      EndDate: '',
      EndDate1: '',
      getPopupContainer: () => document.querySelector('.zxzbul li'),
      spinning: true,
      lastPrice: null
    })
    const newsIndexDetails = ref<any>(null)

    // 加载数据
    const loadData = () => {
      const route: any = useRoute()
      const market = isLocalDev ? 'NASDAQ' : (route.query.market as string)
      const symbol = isLocalDev ? 'AAPL' : (route.query.code as string)

      const data = {
        data: {
          market,
          symbol,
        },
        headers: {
          token: props.token || '3d5eff0d3c7ac7f3af30c337dcdf6944'
        }
      }

      f10ApiUS.getGszb(data).then((res: any) => {
        if (res && res.data) {
          newsIndexDetails.value = res.data
          pageData.spinning = false
        } else {
          newsIndexDetails.value = null
          pageData.spinning = false
        }
      }).catch(() => {
        newsIndexDetails.value = null
        pageData.spinning = false
      })
    }

    pageData.list = computed(() => {
      return setlist()
    })
    // 工具函数
    // 报告类型映射函数
    function getReportTypeName(reportType: number | null | undefined): string {
      if (reportType === null || reportType === undefined) return '未知报告'

      const typeMap: { [key: number]: string } = {
        1: '一季报',
        2: '中报',
        3: '三季报(累积)',
        4: '年报'
      }

      return typeMap[reportType] || '未知报告'
    }

    function formatNumber(value: any, type: string = 'default') {
      // 空值处理
      if (value === null || value === undefined || value === '') return '—'

      const num = Number(value)
      if (isNaN(num)) return '—'

      switch (type) {
        case 'decimal2':
          return num.toFixed(2)

        case 'decimal4':
          return num.toFixed(4)

        case 'unit': {
          if (Math.abs(num) >= 1e12) return (num / 1e12).toFixed(2) + '万亿'
          if (Math.abs(num) >= 1e8) return (num / 1e8).toFixed(2) + '亿'
          if (Math.abs(num) >= 1e4) return (num / 1e4).toFixed(2) + '万'
          return num.toFixed(2)
        }

        case 'percent':
          return num + '%'

        case 'percentWithColor': {
          const pct = num
          return {
            text: pct.toFixed(2) + '%',
            color: pct > 0 ? 'red' : pct < 0 ? 'green' : 'inherit'
          }
        }

        default:
          return num
      }
    }

    function setlist() {
      const d = newsIndexDetails.value || {}
      pageData.spinning = false
      return [
        { name: '市盈率 (TTM)', num: formatNumber(d.ttmPeRate, 'decimal2') },
        { name: '市净率', num: formatNumber(d.dynPbRate, 'decimal2') },
        { name: '每股收益 (元)', num: formatNumber(d.basicEps, 'decimal2') },
        { name: '每股净资产 (元)', num: formatNumber(d.netAssetPs, 'decimal2') },

        { name: '营业收入 (元)', num: formatNumber(d.totalOperatingRevenue, 'unit') },
        { name: '营业收入同比', num: formatNumber(d.totalOperatingRevenueYoy * 100, 'percentWithColor'), },
        { name: '归母净利润', num: formatNumber(d.npParentCompanyOwners, 'unit') },
        { name: '归母净利润同比', num: formatNumber(d.npParentCompanyOwnersYoy * 100, 'percentWithColor'), },

        { name: '毛利率', num: formatNumber(d.grossIncomeRatio, 'percent') },
        { name: '净利率', num: formatNumber(d.netProfitRatio, 'percent') },
        { name: '', num: '' },
        { name: '', num: '' }
      ]
    }


    function isoverflow(e: any, index: number) {
      const text = e.target.outerText
      pageData.tooltip[text] = e.currentTarget.scrollWidth > e.currentTarget.clientWidth
      if (pageData.tooltip[text]) {
        pageData.overflow[text + index] = true
      }
    }
    function hidetool(index: number, text: string) {
      pageData.overflow[text + index] = false
    }
    onMounted(() => {
      loadData()

      if (route.query.code && route.query.market) {
        console.log('重新监听===', route.query.code, route.query.market)
        // ws.websocket.safeSubscribeDYNA(route.query.code, route.query.market)
        ws.websocket.on('onDYNA', msg => {
          console.log('打印数据====```', pageData.lastPrice)
          const _data = msg.QuoteData
          // 停牌
          if (_data.DynaData[0].InstStatus === 6) {
            pageData.lastPrice = null
          } else {
            if (_data && _data.DynaData && (_data.DynaData || []).length > 0) {
              pageData.lastPrice = _data.DynaData[0].LastPrice || null
              console.log('打印数据====', pageData.lastPrice)
            }
          }
        })
      }
      console.log(pageData.lastPrice, '========')
    })
    onUnmounted(() => {
      ws.websocket.safeUnsubscribeDYNA(route.query.code, route.query.market)
    })

    return {
      ...toRefs(pageData),
      isoverflow,
      hidetool,
      newsIndexDetails,
      getReportTypeName,
      moment: window.moment,
      setquarter: globalsets.setquarter
    }
  }
})
